import React, { useState } from 'react';
import cx from 'classnames';

import ConfigureAddressCollectionPreview from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionPreview';
import ConfigureAddressCollectionLinkForm from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkForm';

import ConfigureAddressCollectionFormValues from 'components/manage/guestlist/addressCollection/@types/formValues';
import { ConfigureAddressCollectionPhotoUploaderStateProps } from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionMobileContainer';

import styles from './ConfigureAddressCollectionMobileContainer.module.less';

type ConfigureAddressCollectionMobileContainerProps = ConfigureAddressCollectionPhotoUploaderStateProps & {
  previewData: ConfigureAddressCollectionFormValues;
  onFormSpy: (values: ConfigureAddressCollectionFormValues) => void;
};

enum CurrentTab {
  EDIT = 'edit',
  PREVIEW = 'preview',
}

const ConfigureAddressCollectionMobileContainer: React.FC<ConfigureAddressCollectionMobileContainerProps> = ({
  previewData,
  onFormSpy,
}) => {
  const [currentTab, setCurrentTab] = useState<CurrentTab>(CurrentTab.EDIT);
  const [currentStep, setCurrentStep] = useState<number>(1); // mobile form is split into 1) upload photo; 2) rest of form fields

  const renderTabs = (): JSX.Element => (
    <div className={styles.tabsContainer}>
      <button
        className={cx(styles.tab, { [styles.active]: currentTab === CurrentTab.EDIT })}
        onClick={(): void => setCurrentTab(CurrentTab.EDIT)}
      >
        Edit Link
      </button>
      <button
        className={cx(styles.tab, { [styles.active]: currentTab === CurrentTab.PREVIEW })}
        onClick={(): void => setCurrentTab(CurrentTab.PREVIEW)}
      >
        Preview Link
      </button>
    </div>
  );

  return (
    <>
      {renderTabs()}
      <div className={styles.container}>
        <ConfigureAddressCollectionLinkForm
          setCurrentStep={setCurrentStep}
          onFormSpy={onFormSpy}
          currentStep={currentStep}
          className={cx({ [styles.hide]: currentTab !== CurrentTab.EDIT })}
        />
        <ConfigureAddressCollectionPreview
          previewData={previewData}
          className={cx({ [styles.hide]: currentTab !== CurrentTab.PREVIEW })}
        />
      </div>
    </>
  );
};

export default ConfigureAddressCollectionMobileContainer;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionMobileContainer/ConfigureAddressCollectionMobileContainer.tsx